module.exports = __webpack_public_path__ + "static/james-bd957a583737260f4a608f9fa4ce5731.jpg";